import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SwapSuccess.css';

const SwapSuccess: React.FC = () => {
  const navigate = useNavigate();

  const handleTransactionDetails = () => {
    navigate('/swap-details');
  };

  const handleMakeAnotherSwap = () => {
    navigate('/swap');
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="app-container">
      <div className="mobile-frame">
        <div className="mobile-notch"></div>
        <div className="mobile-screen">
          <div className="swap-success-container">
            <div className="swap-success-content">
              {/* Success Icon */}
              <div className="swap-success-icon-wrapper">
                <div className="swap-success-icon-bg">
                  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                    <path d="M20 32L28 40L44 24" stroke="#22C35E" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>

              {/* Success Heading */}
              <h1 className="swap-success-heading">
                Swap Successful!
              </h1>

              {/* Success Message */}
              <p className="swap-success-message">
                Your crypto has been swapped successfully
              </p>

              {/* Transaction Details Card */}
              <div className="swap-success-details-card">
                <div className="swap-success-detail-section">
                  <span className="swap-success-detail-label">Swapped</span>
                  <div className="swap-success-detail-amount-row">
                    <span className="swap-success-detail-amount">10000 USDT</span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M7 13L13 7M13 7H7M13 7V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>

                <div className="swap-success-divider"></div>

                <div className="swap-success-detail-section">
                  <span className="swap-success-detail-label">Received</span>
                  <span className="swap-success-detail-amount swap-success-detail-amount-highlight">65.3381 SOL</span>
                </div>

                <div className="swap-success-divider"></div>

                <div className="swap-success-detail-row">
                  <span className="swap-success-detail-label">Transaction ID</span>
                  <span className="swap-success-detail-value">TXN56O85COBR</span>
                </div>

                <div className="swap-success-detail-row">
                  <span className="swap-success-detail-label">Date & Time</span>
                  <span className="swap-success-detail-value">11/5/2025, 4:29:56 AM</span>
                </div>

                <div className="swap-success-detail-row">
                  <span className="swap-success-detail-label">Status</span>
                  <span className="swap-success-status-badge">Completed</span>
                </div>
              </div>

              {/* Action Buttons */}
              <button className="swap-success-button-primary" onClick={handleTransactionDetails}>
                Transaction details
              </button>

              <button className="swap-success-button-secondary" onClick={handleMakeAnotherSwap}>
                Make Another Swap
              </button>

              <button className="swap-success-button-text" onClick={handleBackToHome}>
                Back to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwapSuccess;